import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReadMoreComponentDef } from '@df/ui/display/read-more.component.def';

@Component({
    selector: 'read-more',
    template: `
        @if (begining && !isMoreVisible) {
            <span [innerHtml]="begining.trim()"></span>
        }
        @if (!begining && !isMoreVisible) {
            <span [innerHtml]="text"></span>
        }
        <span [class.ng-hide]="!isMoreVisible" [innerHtml]="text"></span>
        @if (begining) {
            @if (!isMoreVisible) {
                <span>...</span>
            }
            <span>&nbsp;</span>
            <span (click)="toggle()" class="link cursor-pointer s2"
                >{{ (isMoreVisible ? 'View&nbsp;less' : 'View&nbsp;more') | translate }}
            </span>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReadMoreComponent extends ReadMoreComponentDef {
    override toggle(to = !this.isMoreVisible): void {
        this.timeoutService.setTimeout(() => {
            this.isMoreVisible = to;
            this.changeDetectorRef.detectChanges();
        }, 50);
    }
}
